// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonValidation = {
  required: "${label}を入力してください",
  stringMin: "${label}は ${min} 文字以上で入力してください",
  stringMax: "${label}は ${max} 文字以内で入力してください",
  numberRange: "${label}は ${min} から ${max} の範囲で入力してください",
  types: {
    email: "${label}は有効なメールアドレスではありません",
    number: "${label}は有効な数値ではありません",
    url: "${label}は有効な URL ではありません",
  },
} as const;
